import axios from "axios";

const baseURL = 'http://18.134.133.59:4000/api/v1.0';

export const fetchEvaluatorList = async () =>{
    const { data } = await axios.get(`${baseURL}/evalutor-list`);
    const evaluatorList = data.Evaluator.map(evaluator => {
        return {
            id: evaluator.evaluator_id,
            access_code: evaluator.evaluator_access_code,
            full_name: evaluator.evaluator_name,
            email: evaluator.evaluator_email,
            image: evaluator.evaluator_image,
            address: evaluator.evaluator_address,
            lga: evaluator.evaluator_lga,
            zone: evaluator.evaluator_zone,
            state: evaluator.evaluator_state,
            status: evaluator.account_status,
            createdAt: evaluator.date_created
        }
    })

    return evaluatorList;
};